import DepositContainer from './DepositContainer';
export const DepositIndex = {
  DepositContainer,
};
